<script>
import appConfig from '@src/app.config';

export default {
  data() {
    return {
      dsbl_btn: false,

      default_item: {
        user_id: '',
        user: {},
        mls_id: '',
        mls: {},
        mls_title: '',
        website: '',
        on_map: '0',
        StandardStatus: 'Awaiting Forms',
        PropertyType: 'Residential',
        PropertySubType: 'Single Family Residence',
        StreetNumber: '',
        StreetDirPrefix: '',
        StreetName: '',
        StreetSuffix: '',
        StreetDirSuffix: '',
        UnitNumber: '',
        Address: '',
        City: '',
        StateOrProvince: '',
        CountyOrParish: '',
        Country: 'United States',
        PostalCode: '',
        ListPrice: 0.00,
        ListOfficeName: '',
        ListAgentFullName: '',
        ListOfficeEmail: '',
        ListOfficePhone: '',
        OwnerName: '',
        OwnerEmail: '',
        OwnerPhone: '',
        Owners: [],
        buying: '',
        is_realtor: '',
        has_realtor: '',
        referred_by: '',
        referred_name: '',
        MailingAddress: '',
        MailingCity: '',
        MailingStateOrProvince: '',
        MailingPostalCode: '',
        additional_input: {},
        sign_company: {},
      },
      item: {
        user: {},
        mls: {},
        Owners: [],
        additional_input: {},
        sign_company: {},
      },

      loading_users: true,
      users: [],

      loading_mlss: true,
      mlss: [],

      stages: [
        // {name: 'Awaiting Order', value: 'Awaiting Order'},
        {name: 'Awaiting Forms', value: 'Awaiting Forms'},
        {name: 'Awaiting Photos', value: 'Awaiting Photos'},
        {name: 'Awaiting Signatures', value: 'Awaiting Signatures'},
        {name: 'Awaiting Listing', value: 'Awaiting Listing'},
        {name: 'Coming Soon', value: 'Coming Soon'},
        {name: 'Active', value: 'Active'},
        {name: 'Active Under Contract', value: 'Active Under Contract'},
        {name: 'Pending', value: 'Pending'},
        {name: 'Delete', value: 'Delete'},
        {name: 'Expired', value: 'Expired'},
        {name: 'Hold', value: 'Hold'},
        {name: 'Incomplete', value: 'Incomplete'},
        {name: 'Withdrawn', value: 'Withdrawn'},
        {name: 'Canceled', value: 'Canceled'},
        {name: 'Closed', value: 'Closed'},
        {name: 'Trash', value: 'Trash'},
      ],
      property_types: [
        {name: 'Business Opportunity', value: 'Business Opportunity'},
        {name: 'Commercial Lease', value: 'Commercial Lease'},
        {name: 'Commercial Sale', value: 'Commercial Sale'},
        {name: 'Farm', value: 'Farm'},
        {name: 'Land', value: 'Land'},
        {name: 'Manufactured In Park', value: 'Manufactured In Park'},
        {name: 'Residential', value: 'Residential'},
        {name: 'Residential Income', value: 'Residential Income'},
        {name: 'Residential Lease', value: 'Residential Lease'},
      ],
      property_sub_types: [
        {name: 'Apartment', value: 'Apartment'},
        {name: 'Boat Slip', value: 'Boat Slip'},
        {name: 'Cabin', value: 'Cabin'},
        {name: 'Condominium', value: 'Condominium'},
        {name: 'Deeded Parking', value: 'Deeded Parking'},
        {name: 'Duplex', value: 'Duplex'},
        {name: 'Farm', value: 'Farm'},
        {name: 'Manufactured Home', value: 'Manufactured Home'},
        {name: 'Manufactured On Land', value: 'Manufactured On Land'},
        {name: 'Mobile Home', value: 'Mobile Home'},
        {name: 'Own Your Own', value: 'Own Your Own'},
        {name: 'Quadruplex', value: 'Quadruplex'},
        {name: 'Ranch', value: 'Ranch'},
        {name: 'Single Family Residence', value: 'Single Family Residence'},
        {name: 'Stock Cooperative', value: 'Stock Cooperative'},
        {name: 'Timeshare', value: 'Timeshare'},
        {name: 'Townhouse', value: 'Townhouse'},
        {name: 'Triplex', value: 'Triplex'},
        {name: 'Agriculture', value: 'Agriculture'},
        {name: 'Business', value: 'Business'},
        {name: 'Hotel-Motel', value: 'Hotel-Motel'},
        {name: 'Industrial', value: 'Industrial'},
        {name: 'Mixed Use', value: 'Mixed Use'},
        {name: 'Multi Family', value: 'Multi Family'},
        {name: 'Office', value: 'Office'},
        {name: 'Retail', value: 'Retail'},
        {name: 'Unimproved Land', value: 'Unimproved Land'},
        {name: 'Warehouse', value: 'Warehouse'},
      ],
      directions: [
        {name: 'E', value: 'E'},
        {name: 'N', value: 'N'},
        {name: 'NE', value: 'NE'},
        {name: 'NW', value: 'NW'},
        {name: 'S', value: 'S'},
        {name: 'SE', value: 'SE'},
        {name: 'SW', value: 'SW'},
        {name: 'W', value: 'W'},
        {name: '-', value: '-'},
      ],
      states: [
        {value: 'AL', name: 'Alabama'},
        {value: 'AK', name: 'Alaska'},
        {value: 'AZ', name: 'Arizona'},
        {value: 'AR', name: 'Arkansas'},
        {value: 'CA', name: 'California'},
        {value: 'CO', name: 'Colorado'},
        {value: 'CT', name: 'Connecticut'},
        {value: 'DE', name: 'Delaware'},
        {value: 'DC', name: 'District Of Columbia'},
        {value: 'FL', name: 'Florida'},
        {value: 'GA', name: 'Georgia'},
        {value: 'HI', name: 'Hawaii'},
        {value: 'ID', name: 'Idaho'},
        {value: 'IL', name: 'Illinois'},
        {value: 'IN', name: 'Indiana'},
        {value: 'IA', name: 'Iowa'},
        {value: 'KS', name: 'Kansas'},
        {value: 'KY', name: 'Kentucky'},
        {value: 'LA', name: 'Louisiana'},
        {value: 'ME', name: 'Maine'},
        {value: 'MD', name: 'Maryland'},
        {value: 'MA', name: 'Massachusetts'},
        {value: 'MI', name: 'Michigan'},
        {value: 'MN', name: 'Minnesota'},
        {value: 'MS', name: 'Mississippi'},
        {value: 'MO', name: 'Missouri'},
        {value: 'MT', name: 'Montana'},
        {value: 'NE', name: 'Nebraska'},
        {value: 'NV', name: 'Nevada'},
        {value: 'NH', name: 'New Hampshire'},
        {value: 'NJ', name: 'New Jersey'},
        {value: 'NM', name: 'New Mexico'},
        {value: 'NY', name: 'New York'},
        {value: 'NC', name: 'North Carolina'},
        {value: 'ND', name: 'North Dakota'},
        {value: 'OH', name: 'Ohio'},
        {value: 'OK', name: 'Oklahoma'},
        {value: 'OR', name: 'Oregon'},
        {value: 'PA', name: 'Pennsylvania'},
        {value: 'RI', name: 'Rhode Island'},
        {value: 'SC', name: 'South Carolina'},
        {value: 'SD', name: 'South Dakota'},
        {value: 'TN', name: 'Tennessee'},
        {value: 'TX', name: 'Texas'},
        {value: 'UT', name: 'Utah'},
        {value: 'VT', name: 'Vermont'},
        {value: 'VA', name: 'Virginia'},
        {value: 'WA', name: 'Washington'},
        {value: 'WV', name: 'West Virginia'},
        {value: 'WI', name: 'Wisconsin'},
        {value: 'WY', name: 'Wyoming'},
      ],
      referral_types: [
        {value: 'phone call', name: 'Phone Call'},
        {value: 'text message', name: 'Text Message'},
        {value: 'television ad', name: 'Television Ad'},
        {value: 'radio ad', name: 'Radio Ad'},
        {value: 'internet ad', name: 'Internet Ad'},
        {value: 'facebook', name: 'Facebook'},
        {value: 'instagram', name: 'Instagram'},
        {value: 'event', name: 'Event'},
        {value: 'mail brochure', name: 'Mail - Brochure'},
        {value: 'mail postcard', name: 'Mail - Postcard'},
        {value: 'referral', name: 'Referral from another client'},
        {value: 'repeat client', name: 'Repeat Client'},
      ],

    }
  },
  watch: {
    'item.user.id': { handler: function(n, o) {
      if(n) {
        this.item.user_id = n;
        this.loading_users = true;
        this.$http.get('/api/users/fetch', {params:{paginate:2, page:1, total:0, wheres: {id: this.item.user_id}}}).then(res => {
          // console.log(res);
          if(res.data.data.length == 1) { this.item.user = res.data.data[0]; } else { this.item.user = {}; }
          if(this.item.user.referred_by) { this.item.referred_by = this.item.user.referred_by; } else { this.item.referred_by = ""; }
          if(this.item.user.referred_name) { this.item.referred_name = this.item.user.referred_name; } else { this.item.referred_name = ""; }
          if(this.item.user.MailingAddress) { this.item.MailingAddress = this.item.user.MailingAddress; } else { this.item.MailingAddress = ""; }
          if(this.item.user.MailingCity) { this.item.MailingCity = this.item.user.MailingCity; } else { this.item.MailingCity = ""; }
          if(this.item.user.MailingStateOrProvince) { this.item.MailingStateOrProvince = this.item.user.MailingStateOrProvince; } else { this.item.MailingStateOrProvince = ""; }
          if(this.item.user.MailingPostalCode) { this.item.MailingPostalCode = this.item.user.MailingPostalCode; } else { this.item.MailingPostalCode = ""; }
          this.loading_users = false;
        }).catch(res => { this.loading_users = false; this.popupErrors(res); });
      } else {
        this.item.user_id = '';
        this.item.user = {};
        this.item.referred_by = "";
        this.item.referred_name = "";
        this.item.MailingAddress = "";
        this.item.MailingCity = "";
        this.item.MailingStateOrProvince = "";
        this.item.MailingPostalCode = "";
      }
    }},
    'item.mls': { handler: function(n, o) {
      this.item.mls_id = n.id;
      this.item.mls = n;
    }},
    'item.StreetNumber': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
    }},
    'item.StreetDirPrefix': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
    }},
    'item.StreetName': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
    }},
    'item.StreetDirSuffix': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
    }},
    'item.StreetSuffix': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
    }},
    'item.UnitNumber': {handler: function(n, o) {
      this.item.Address = (
        (this.item.StreetNumber ? ' '+this.item.StreetNumber : '') +
        (this.item.StreetDirPrefix ? ' '+this.item.StreetDirPrefix : '') +
        (this.item.StreetName ? ' '+this.item.StreetName : '') +
        (this.item.StreetSuffix ? ' '+this.item.StreetSuffix : '') +
        (this.item.StreetDirSuffix ? ' '+this.item.StreetDirSuffix : '') +
        (this.item.UnitNumber ? ' '+this.item.UnitNumber : '')
      ).replace(/\s\s+/g, ' ').trim();
    }},
  },
  computed: {
  
  },
  created() {
    this.default_item.website = this.website_id;
    if(this.$route && this.$route.path.includes("/contacts") && this.$route.params.id) { this.default_item.user_id = this.$route.params.id; }
    if(this.app_name) { this.default_item.ListOfficeName = this.app_name; }
    if(this.app_email) { this.default_item.ListOfficeEmail = this.app_email; }
    if(this.app_phone) { this.default_item.ListOfficePhone = this.app_phone; }
    
    this.item = JSON.parse(JSON.stringify(this.default_item));

    this.fetch_users();
    this.fetch_mlss();
  },
  methods: {
    fetch_users() {
      this.loading_users = true;
      this.$http.get('/api/users/fetch', {params:{paginate:1000, page:1, total:0, selects:['id','email','name'], orderbys:{last_active:'desc'}}}).then(res => {
        // console.log(res);
        this.users = res.data.data;
        if(this.$route && this.$route.path.includes("/contacts") && this.$route.params.id) {
          for(var i in this.users) { if(this.users[i].id == this.item.user_id) { this.item.user = this.users[i]; } }
        }
        this.loading_users = false;
      }).catch(res => { this.loading_users = false; this.popupErrors(res); });
    },
    fetch_mlss() {
      this.loading_mlss = true;
      this.$http.get('/api/mlss/fetch', {params:{paginate:1000, page:1, total:0, selects:['id','title','office_name']}}).then(res => {
        // console.log(res);
        this.mlss = res.data.data;
        this.loading_mlss = false;
      }).catch(res => { this.loading_mlss = false; this.popupErrors(res); });
    },
    add_listing() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.post('/api/listings/admin-store', this.item).then(res => {
        // console.log(res);
        this.item = JSON.parse(JSON.stringify(this.default_item));
        this.$emit('hidemodel');
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
  }
}
</script>

<template>
  <div>
    <b-form @submit.prevent="add_listing">
      <div class="p-4">
        <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Listing Settings :</h5>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Stage :" :Options="stages" v-model="item.StandardStatus" Required></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="item.website" :Options="app_website_ids" Title="Website :" Required></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="item.on_map" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]" Title="On map :" Required></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Property Type :" :Options="property_types" v-model="item.PropertyType" Definition="A list of types of properties such as Residential, Lease, Income, Land, Mobile, Commercial Sale, etc..." Required></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Property Sub Type :" :Options="property_sub_types" v-model="item.PropertySubType" Definition="A list of types of residential and residential lease properties, i.e. SFR, Condo, etc. Or a list of Sub Types for Mobile, such as Expando, Manufactured, Modular, etc."></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Listing/MLS ID :" v-model="item.ListingId" Definition=""></w-field>
          </div>
        </div>
        <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Listing Address :</h5>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Street Number :" v-model="item.StreetNumber" Required Definition="The street number portion of a listed property's street address. In some areas the street number may contain non-numeric characters. This field can also contain extensions and modifiers to the street number, such as '1/2' or '-B'. This street number field should not include Prefixes, Direction or Suffixes."></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Street direction :" :Options="directions" v-model="item.StreetDirPrefix" Definition="The direction indicator that precedes the listed property's street name."></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Street Name :" v-model="item.StreetName" Required Definition="The street name portion of a listed property's street address."></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Street Suffix :" v-model="item.StreetSuffix" Definition="The suffix portion of a listed property's street address."></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Street direction :" :Options="directions" v-model="item.StreetDirSuffix" Definition="The direction indicator that follows a listed property's street address."></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Unit/Suite Number :" v-model="item.UnitNumber" Definition="Text field containing the number or portion of a larger building or complex. Unit Number should appear following the street suffix or, if it exists, the street suffix direction, in the street address. Examples are: 'APT G', '55', etc."></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="City :" v-model="item.City" Required Definition="The city in listing address."></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="State :" :Options="states" Required v-model="item.StateOrProvince" Definition="Text field containing the accepted postal abbreviation for the state or province."></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="County/Parish :" v-model="item.CountyOrParish" Definition="The County, Parish or other regional authority"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" Title="Zip code :" v-model="item.PostalCode" Required Definition="The postal code portion of a street or mailing address."></w-field>
          </div>
        </div>

        <h5 class="section-header mt-5 mb-3">
          <i class="spinner-border spinner-border-sm" v-if="loading_users"></i><Icon v-else icon="ri:book-2-line"></Icon> Assigned user
        </h5>
        <p class="text-muted small mb-3">Assign to a specific user. If this user is a client they will be given access to receive invoices and upload photos. If the person you are looking for is not on this list they must first be created in the Contacts section using their email address as a reference.</p>
        <div v-if="!loading_users" class="row">
          <div class="col-sm-12 mb-2">
            <!-- <pre>{{ item.user_id }}</pre> -->
            <!-- <pre>{{ item.user }}</pre> -->
            <multiselect id="input-lead_recipients" v-model="item.user" :options="users" :preserve-search="true" placeholder="Select..." label="name" track-by="id" required>
              <template slot="singleLabel" slot-scope="props">{{props.option.email}} <span class="text-muted">({{props.option.name}})</span></template>
              <template slot="option" slot-scope="props">{{props.option.email}} <span class="text-muted">({{props.option.name}})</span></template>
            </multiselect>
          </div>
        </div>

        <h5 class="section-header mt-5 mb-3">
          <i class="spinner-border spinner-border-sm" v-if="loading_mlss"></i><Icon v-else icon="ri:book-2-line"></Icon> Assigned MLS
        </h5>
        <p class="text-muted small mb-3">Assign to a specific user. If this user is a client they will be given access to receive invoices and upload photos. If the person you are looking for is not on this list they must first be created in the Contacts section using their email address as a reference.</p>
        <div v-if="!loading_mlss" class="row">
          <div class="col-sm-12 mb-2">
            <multiselect id="input-lead_recipients" v-model="item.mls" :options="mlss" :preserve-search="true" placeholder="Select..." label="name" track-by="id" required>
              <template slot="singleLabel" slot-scope="props">{{props.option.title}} <span class="text-muted">({{props.option.office_name}})</span></template>
              <template slot="option" slot-scope="props">{{props.option.title}} <span class="text-muted">({{props.option.office_name}})</span></template>
            </multiselect>
          </div>
        </div>

        <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> List Price :</h5>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="Money" Title="List Price :" v-model="item.ListPrice" :Decimal="false" Required Definition=""></w-field>
          </div>
        </div>
        <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Owner Information :</h5>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Owner Name :" v-model="item.OwnerName" Definition=""></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Owner Email :" v-model="item.OwnerEmail" Definition=""></w-field>  
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Phone" Title="Owner Phone :" v-model="item.OwnerPhone" Definition=""></w-field>
          </div>
          <div class="col-sm-12">
            <h6 class="mt-3 mb-0">Additional Owners</h6>
            <p class="text-muted small mb-2">Use this section to add any additional property owners.</p>
            <div v-for="(owner, owner_i) in item.Owners" :key="owner_i" class="row align-items-end">
              <div class="col-sm" data-aos="fade-zoom-in">
                <div class="form-group">
                  <label :for="'field-oname'+owner_i">Owner name</label>
                  <input :id="'field-oname'+owner_i" name="name" type="text" class="form-control" v-model="owner.name">
                  <small class="text-muted"></small>
                </div>
              </div>
              <div class="col-sm" data-aos="fade-zoom-in">
                <div class="form-group">
                  <label :for="'field-oemail'+owner_i">Owner email</label>
                  <input :id="'field-oemail'+owner_i" name="email" type="text" class="form-control" v-model="owner.email">
                  <small class="text-muted"></small>
                </div>
              </div>
              <div class="col-sm" data-aos="fade-zoom-in">
                <div class="form-group">
                  <label :for="'field-ophone'+owner_i">Owner phone</label>
                  <the-mask :id="'field-ophone'+owner_i" type="tel" class="form-control" v-model="owner.phone" :mask="['(###) ###-####']" />
                  <small class="text-muted"></small>
                </div>
              </div>
              <div class="col-sm _w-70 _w-m-70">
                <button class="btn btn-white mb-2" type="button" v-tippy content="Delete" @click="item.Owners.splice(owner_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
              </div>
            </div>
            <div class="">
              <button class="btn btn-light" type="button" @click="item.Owners.push({name: '', email: '', phone: ''})"><Icon icon="ri:add-line" height="18"></Icon> Add owner</button>
            </div>
          </div>
        </div>
        <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Mailing Address :</h5>
        <div class="row">
          <div class="col-sm-12">
            <w-field SimpleDataType="String" Title="Mailing Address :" v-model="item.MailingAddress" Definition=""></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Mailing City :" v-model="item.MailingCity" Definition=""></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Mailing State :" v-model="item.MailingStateOrProvince" Definition=""></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Mailing Zip Code :" v-model="item.MailingPostalCode" Definition=""></w-field>
          </div>
        </div>
        <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Listing Office :</h5>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Listing Office Name :" v-model="item.ListOfficeName" Definition=""></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Listing Agent Full Name :" v-model="item.ListAgentFullName" Definition=""></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Listing Office Email :" v-model="item.ListOfficeEmail" Definition=""></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Listing Office Phone :" v-model="item.ListOfficePhone" Definition=""></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Listing Office MLS ID :" v-model="item.ListOfficeMlsId" Definition=""></w-field>
          </div>
        </div>
        <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Additional Details :</h5>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="item.buying" :Options="[{name: 'Yes', value: 'Yes'}, {name: 'No', value: 'No'}]" Title="Looking to buy property :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="item.is_realtor" :Options="[{name: 'Yes', value: 'Yes'}, {name: 'No', value: 'No'}]" Title="Is a Realtor :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="item.has_realtor" :Options="[{name: 'Yes', value: 'Yes'}, {name: 'No', value: 'No'}]" Title="Currently working with a realtor :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="How did you hear about us :" :Options="referral_types" v-model="item.referred_by" Definition=""></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" Title="Referred by :" v-model="item.referred_name" Definition=""></w-field>
          </div>
        </div>
        <h5 class="section-header mt-5 mb-3"><Icon icon="ri:book-2-line"></Icon> Sign Company :</h5>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" Title="Property occupied by :" :Options="['Tenant', 'Owner', 'Vacant']" v-model="item.sign_company.occupancy" Definition=""></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" Title="Are dogs present :" :Options="['Yes', 'No']" v-model="item.sign_company.dogs" Definition=""></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" Title="How will the property be accessed :" :Options="['Meet occupant at property', 'Meet assistant at property', 'Lockbox', 'Other']" v-model="item.sign_company.property_access" Definition=""></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" Title="Describe how the property will be accessed :" v-model="item.sign_company.property_access_other" Definition=""></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Date" Title="Desired date of service :" v-model="item.sign_company.schedule_date" Definition=""></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Time" Title="Desired time of service :" v-model="item.sign_company.schedule_time" Definition=""></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" Title="Which is more important to you :" :Options="['Date', 'Time']" v-model="item.sign_company.schedule_preference" Definition=""></w-field>
          </div>
        </div>
      </div>
      <footer class="modal-footer">
        <button type="button" class="btn btn-light" @click="$emit('hidemodel')" :disabled="dsbl_btn"><Icon icon="ri:close-fill" /> Cancel</button>
        <button type="submit" class="btn btn-primary" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
      </footer>
    </b-form>
  </div>
</template>
